// Form rules for a client, apart from the component that draws them.
//
// They live in utils/ and not next to the JSX for a concrete reason: a module
// that exports both a component and plain functions breaks Vite's Fast
// Refresh, and the template's lint says so out loud.
//
// Limits mirror data/schemas/client.js in the backend. They are repeated here
// to fail before the round trip, NOT to replace the server's check — what
// comes back in `error.fields` is the authority.

export const NAME_MAX = 160;
export const CONTACT_MAX = 180;

// Only 2 and 1 are offered. `0` is what the backend writes when a client is
// deactivated through DELETE, not a state a person picks from a dropdown.
export const STATUS_OPTIONS = [
    { value: 2, label: 'Activo' },
    { value: 1, label: 'Inactivo' },
];

export const EMPTY_VALUES = { name: '', contact: '', notes: '', status: 2 };

// A record as the form holds it: never null, because an input whose value goes
// from null to a string switches from uncontrolled to controlled and React
// complains — with the cursor jumping to the end as the visible symptom.
export function valuesFrom(client) {
    return {
        name: client?.name ?? '',
        contact: client?.contact ?? '',
        notes: client?.notes ?? '',
        status: client?.status ?? 2,
    };
}

export function validate(values) {
    const errors = {};
    const name = values.name.trim();

    if (!name) errors.name = 'El nombre del cliente es requerido';
    else if (name.length > NAME_MAX) errors.name = `No puede pasar de ${NAME_MAX} caracteres`;

    if (values.contact.length > CONTACT_MAX) {
        errors.contact = `No puede pasar de ${CONTACT_MAX} caracteres`;
    }
    return errors;
}

// The payload the API takes. Empty optional fields travel as null and not as
// '': the columns are nullable, and an empty string is a value that says
// "somebody typed nothing here", which is not the same as "unknown".
export function toPayload(values) {
    return {
        name: values.name.trim(),
        contact: values.contact.trim() || null,
        notes: values.notes.trim() || null,
        status: Number(values.status),
    };
}
